import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_register() {
  const title = "Register User ";
  const navigate = useNavigate();
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [autocomplete, setAutocomplete] = useState(null);
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [clients, setClients] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    location: "",
    generalStaffType: "",
    panCard: null,
    drivingLicense_front: null,
    drivingLicense_back: null,
    aadhar_front: null,
    aadhar_back: null,
    parentAadharCard_front: null,
    parentAadharCard_back: null,
    voterCard_front: null,
    voterCard_back: null,
    police_verification: null,
  });
  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;

    if (files) {
      if (files[0].size > 1024 * 1024) {
        // Check if the file exceeds the size limit
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "File size exceeds 1MB limit",
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: files[0], // Ensure the file is added to formData state
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setFormData((prevFormData) => ({
        ...prevFormData,
      }));
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.aadhar_front)
      newErrors.aadhar_front = "Aadhar front is required";
    if (!formData.aadhar_back)
      newErrors.aadhar_back = "Aadhar back is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const formDataToSend = new FormData();

    // Basic fields
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phoneNumber", formData.phoneNumber);
    formDataToSend.append("password", formData.password);
    formDataToSend.append("generalStaffType", formData.generalStaffType);
    formDataToSend.append("location", formData.location);
    // File fields (map to backend schema)
    if (formData.panCard) formDataToSend.append("panCard", formData.panCard);

    if (formData.drivingLicense_front)
      formDataToSend.append("license_front", formData.drivingLicense_front);
    if (formData.drivingLicense_back)
      formDataToSend.append("license_back", formData.drivingLicense_back);

    if (formData.aadhar_front)
      formDataToSend.append("aadhar_front", formData.aadhar_front);
    if (formData.aadhar_back)
      formDataToSend.append("aadhar_back", formData.aadhar_back);

    if (formData.voterCard_front)
      formDataToSend.append("voter_front", formData.voterCard_front);
    if (formData.voterCard_back)
      formDataToSend.append("voter_back", formData.voterCard_back);

    if (formData.parentAadharCard_front)
      formDataToSend.append(
        "parentAadhar_front",
        formData.parentAadharCard_front
      );
    if (formData.parentAadharCard_back)
      formDataToSend.append(
        "parentAadhar_back",
        formData.parentAadharCard_back
      );

    if (formData.police_verification)
      formDataToSend.append(
        "police_verification",
        formData.police_verification
      );

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/joining-form/submit`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        navigate("/registeration");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDateChange = (date, fieldName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: date,
    }));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="name">
                  <b>Name *</b>
                </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="form-control"
                  name="name"
                  onChange={onChangeHandler}
                  value={formData.name || ""}
                />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="email">
                  <b>Email </b>
                </label>
                <input
                  type="text"
                  placeholder=" Enter Your Email"
                  className="form-control"
                  name="email"
                  onChange={onChangeHandler}
                  value={formData.email || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="phoneNumber">
                  <b>Phone Number </b>
                </label>
                <input
                  type="text"
                  placeholder="Enter your Phonenumber here"
                  className="form-control"
                  name="phoneNumber"
                  onChange={onChangeHandler}
                  value={formData.phoneNumber || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="password">
                  <b>Password </b>
                </label>
                <input
                  type="text"
                  placeholder="Enter your password here"
                  className="form-control"
                  name="password"
                  onChange={onChangeHandler}
                  value={formData.password || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="generalStaffType">
                  <b>Staff Type </b>
                </label>
                <input
                  type="text"
                  placeholder="Enter your generalStaffType here"
                  className="form-control"
                  name="generalStaffType"
                  onChange={onChangeHandler}
                  value={formData.generalStaffType || ""}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="location">
                  <b>Location </b>
                </label>
                <input
                  type="text"
                  placeholder="Enter Location  here"
                  className="form-control"
                  name="location"
                  onChange={onChangeHandler}
                  value={formData.location || ""}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="drivingLicense_front">
                  <b>Driving License Front *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="drivingLicense_front"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="drivingLicense_back">
                  <b>Driving License Back *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="drivingLicense_back"
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="panCard">
                  <b> Pan Card </b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="panCard"
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="aadhar_front">
                  <b>Aadhar Card Front *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="aadhar_front"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="aadhar_back">
                  <b>Aadhar Card Back *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="aadhar_back"
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="voterCard_front">
                  <b>Voter Card Front *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="voterCard_front"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="voterCard_back">
                  <b>Voter Card Back *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="voterCard_back"
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="parentAadharCard_front">
                  <b>Parent Aadhar Front *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="parentAadharCard_front"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="parentAadharCard_back">
                  <b>Parent Aadhar Back *</b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="parentAadharCard_back"
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="police_verification">
                  <b>Police Verification </b>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="police_verification"
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Registeration
            </button>
          </div>
        </form>
      </div>
      <Modal
        isOpen={isMapOpen}
        onRequestClose={() => setIsMapOpen(false)}
        contentLabel="Map Modal"
      ></Modal>
    </>
  );
}
